import { Map, List, fromJS } from 'immutable'

export function tasks(state = List(), action) {
  switch (action.type) {
    case 'TASKS_FETCH_SUCCESS':
      return fromJS(action.items || [])

    case 'TASK_CREATE_SUCCESS':
      let createdTask = fromJS(action.item || false)
      if (!Map.isMap(createdTask)) return state

      return state.push(createdTask)

    case 'TASK_EDIT_SUCCESS':
      let updatedTask = fromJS(action.item || false)
      if (!Map.isMap(updatedTask)) return state

      return state.map(t => (t.get('id') === updatedTask.get('id') ? updatedTask : t))

    case 'TASK_DELETE_SUCCESS':
      return state.filter(t => t.get('id') !== action.item_id)

    case 'TASK_BATCH_UPDATE':
      let items = action.items || []
      return state.map(task => {
        let updatedTask = items.find(({ id }) => id === task.get('id'))
        return updatedTask ? task.merge(fromJS(updatedTask)) : task
      })

    default:
      return state
  }
}

// TASK_DELETE_LOADING
//
// TASK_DELETE_ERROR

export function tasksLoading(state = false, action) {
  switch (action.type) {
    case 'TASKS_FETCH_LOADING':
      return action.loading || false
    default:
      return state
  }
}

export function tasksError(state = false, action) {
  switch (action.type) {
    case 'TASKS_FETCH_ERROR':
      return action.message || true
    default:
      return state
  }
}

export function rootTaskCreating(state = false, action) {
  switch (action.type) {
    case 'ROOT_CREATE_TASK':
      return action.add || false
    case 'TASK_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

export function rootTaskEditing(state = false, action) {
  switch (action.type) {
    case 'ROOT_EDIT_TASK':
      return action.id || false
    case 'TASK_EDIT_SUCCESS':
      return false
    case 'TASK_DELETE_SUCCESS':
      return false
    default:
      return state
  }
}
